import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sellerServices } from '../services/seller.service';
import { toast } from 'react-hot-toast';

export const useUpdateSellerCodSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sellerServices.updateSellerCodSettings,
    onSuccess: (data, variables) => {
      toast.success(data?.message || 'COD settings updated successfully');
      queryClient.invalidateQueries({ queryKey: ['seller', variables.sellerId] });
      queryClient.invalidateQueries({ queryKey: ['sellers'] });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update COD settings');
    },
  });
};
